export class AhyOperatingPoint {
  airflow!: number;
  staticPressure!: number;
}
